import React from 'react';
import { PageLayout } from '../components/Layout/PageLayout';
import { Heart, Star, Shield, Users } from 'lucide-react';
import { SEO } from '../components/SEO';

const AboutPage: React.FC = () => {
  return (
    <PageLayout>
      <SEO 
        title="About RaveRemedy - Premium Post-Rave Recovery Supplements"
        description="Learn about RaveRemedy's mission to provide premium post-rave recovery supplements for festival-goers. Discover our story, values, and commitment to the rave community's health and wellness."
        keywords="about rave remedy, post-rave recovery supplements company, festival recovery supplements, rave supplement brand, premium recovery supplements"
        canonical="https://raveremedy.com/about"
      />
      <div className="pt-24 pb-16">
        {/* Hero Section */}
        <div className="relative mb-20">
          <div className="absolute inset-0">
            {/* Using a gradient background instead of an image */}
            <div className="absolute inset-0 bg-gradient-to-b from-black via-purple-900/30 to-black" />
          </div>
          
          <div className="relative max-w-4xl mx-auto px-4 text-center pt-16 pb-8">
            <h1 className="text-5xl font-bold gradient-text mb-6">
              About RaveRemedy - Premium Post-Rave Recovery
            </h1>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              Born from the heart of the rave community, <strong>RaveRemedy</strong> is dedicated to providing premium
              <strong>post-rave recovery supplements</strong> that support the wellbeing and vitality of festival-goers.
            </p>
          </div>
        </div>

        {/* Mission Section */}
        <div className="max-w-4xl mx-auto px-4 mb-20">
          <div className="glass-panel rounded-3xl p-8 md:p-12 text-center hover-glow">
            <Heart className="w-16 h-16 text-[#ff00ff] mx-auto mb-6" />
            <h2 className="text-3xl font-bold gradient-text mb-6">Our Mission</h2>
            <p className="text-xl text-gray-300">
              We believe in the power of music, community, and responsible partying. Our mission is to provide 
              premium recovery supplements that support the wellbeing of ravers so they can make the
              most of every experience.
            </p>
          </div>
        </div>

        {/* Product Preview */}
        <div className="max-w-6xl mx-auto px-4 mb-20">
          <div className="relative overflow-hidden rounded-3xl glass-panel">
            <div className="absolute inset-0 bg-gradient-to-r from-[#ff00ff]/20 to-[#00ffff]/20 opacity-30"></div>
            
          </div>
        </div>

      

        {/* Values Section */}
        <div className="max-w-6xl mx-auto px-4 mb-20">
          <h2 className="text-4xl font-bold gradient-text text-center mb-12">Our Values</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="glass-panel rounded-2xl p-6 text-center hover-glow">
              <Shield className="w-12 h-12 text-[#ff00ff] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Safety First</h3>
              <p className="text-gray-300">
                All our products are rigorously tested and made with premium ingredients in GMP-certified facilities.
              </p>
            </div>
            <div className="glass-panel rounded-2xl p-6 text-center hover-glow">
              <Star className="w-12 h-12 text-[#ff00ff] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Quality Guaranteed</h3>
              <p className="text-gray-300">
                We never compromise on quality, using only the finest ingredients backed by scientific research.
              </p>
            </div>
            <div className="glass-panel rounded-2xl p-6 text-center hover-glow">
              <Users className="w-12 h-12 text-[#ff00ff] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Community Focused</h3>
              <p className="text-gray-300">
                We're active members of the rave community, supporting events and promoting responsible partying.
              </p>
            </div>
          </div>
        </div>

      </div>
    </PageLayout>
  );
};

export default AboutPage;